import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Login() {
  const location = useLocation();
  const hasError = new URLSearchParams(location.search).get("error");

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center",
      background: "linear-gradient(168deg,#0D1B2A 0%,#08131F 62%,#0B1A2B 100%)", padding: "24px" }}>
      <div style={{ width: "min(460px, 92vw)", background: "rgba(255,255,255,.04)",
        border: "1px solid rgba(255,255,255,.16)", borderRadius: "18px", padding: "clamp(30px,5vw,46px)" }}>
        <Link to="/" style={{ fontFamily: "var(--display)", fontWeight: 700, letterSpacing: "-.02em",
          fontSize: "1.4rem", color: "#fff", textDecoration: "none" }}>
          Social <span style={{ color: "var(--accent-lift)" }}>Fellows</span>
        </Link>
        <p style={{ fontFamily: "var(--mono)", fontSize: ".64rem", letterSpacing: ".22em",
          textTransform: "uppercase", color: "var(--accent-lift)", margin: "26px 0 10px" }}>
          Admin access
        </p>
        <h1 style={{ fontFamily: "var(--display)", color: "#fff", fontSize: "1.7rem",
          margin: "0 0 14px", letterSpacing: "-.02em" }}>Sign in to manage media</h1>
        <p style={{ color: "rgba(255,255,255,.62)", fontSize: ".98rem", margin: "0 0 28px", lineHeight: 1.6 }}>
          Upload programme photos, partner logos and transparency documents, and review applications.
          Access is restricted to authorised Social Fellows accounts.
        </p>
        {hasError && (
          <p style={{ color: "#ff9b9b", fontFamily: "var(--mono)", fontSize: ".72rem",
            letterSpacing: ".06em", margin: "0 0 18px" }}>
            Sign-in failed or this account is not authorised. Please try again.
          </p>
        )}
        <button onClick={handleLogin} className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}>
          Continue with Google <span className="arw">&rarr;</span>
        </button>
        <Link to="/" style={{ display: "block", marginTop: "22px", textAlign: "center",
          fontFamily: "var(--mono)", fontSize: ".68rem", letterSpacing: ".14em",
          textTransform: "uppercase", color: "rgba(255,255,255,.5)" }}>
          &larr; Back to site
        </Link>
      </div>
    </div>
  );
}
